// extracted by mini-css-extract-plugin
module.exports = {"content":"content__3UG4w","title":"title__1rSkP","control":"control__NORFL","owner":"owner__179Rj"};